export const IsEmpty = (value) =>
  value === null ||
  value === undefined ||
  value === NaN ||
  Object.keys(value).length === 0 ||
  (typeof value === String && value.trim().length === 0) ||
  (typeof value === Array && value.length === 0) ||
  (typeof value === Number && value === 0);
